"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-chevron-up viewbox="0 0 24 14"><path d="M20.641 13.993L9.099 2.449 11.547 0l11.544 11.545-2.45 2.448zM13.995 2.449L2.45 13.994 0 11.545 11.546 0l2.449 2.449z"></path></symbol>';
};